<template>
  <q-page>
    <rate
      v-if="rate"
      :rate="rate"
    />
    <main-header
      img-src="/img/bg-header.jpg"
    />
    <div
      id="why_us"
      class="advantages"
    >
      <div class="container q-py-md">
        <div class="row">
          <div
            v-for="(advantage, key) in $t('pages.index.advantages')"
            :key="key"
            class="col-12 col-sm-6 col-lg-3 text-center q-pa-sm relative-position"
          >
            <router-link
              class="text-black"
              :to="{
                name: 'transfer.new',
              }"
            >
              <h4 class="text-h6 no-wrap">
                <i :class="[`icon-${advantagesIcons[key]}`, 'text-primary']" />
                {{ advantage.title }}
              </h4>
              <div>{{ advantage.text }}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <our-fleet />
  </q-page>
</template>

<script>
import MainHeader from 'components/MainHeader';
import OurFleet from 'components/OurFleet';
import Rate from 'components/Rate';

export default {
  name: 'PageIndex',
  components: {
    Rate,
    MainHeader,
    OurFleet,
  },
  data() {
    return {
      rate: null,
      advantagesIcons: {
        best_price: 'like',
        free_waiting: 'clock_outline',
        no_hidden: 'dollar',
        safe: 'shield',
      },
    };
  },
  mounted() {
    const rateQuery = ['external_rate', 'rate_val', 'rate_key', 'transfer_id'];
    if (rateQuery.every((key) => this.$route.query[key])) {
      this.rate = rateQuery.reduce((acc, el) => {
        acc[el] = this.$route.query[el];
        return acc;
      }, {});
      this.rate.rate_val = +this.rate.rate_val;
    }
  },
};
</script>

<style lang="scss" scoped>
.advantages .col-12:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 30px;
  right: 0;
  width: 1px;
  height: calc(100% - 60px);
  background: #bbb;
  @media (max-width: $breakpoint-md-max) {
    display: none;
  }
}
</style>
